import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ClusterElementViewModel } from 'projects/phdsoft/common/src/lib/models/cluster-element.model'
import { environment } from 'src/environments/environment'

@Injectable({
  providedIn: 'root',
})
export class ClusterService {
  constructor(private http: HttpClient) { }

  RegenerateClustersIfNeeded(pCollection: ClusterElementViewModel[]) {
    return this.http.post<boolean[]>(environment.API_INSPEC + `Cluster/RegenerateClustersIfNeeded`, pCollection)
  }
  RegenerateClustersIfNeededWhenDeleted(pCollection: ClusterElementViewModel) {
    return this.http.post<boolean[]>(environment.API_INSPEC + `Cluster/RegenerateClustersIfNeededWhenDeleted`, pCollection)
  }

  getCurrentClustersByRegionId(data: any) {
    return this.http.post<string[]>(environment.API_INSPEC + `Cluster/GetCurrentClusters`, data)
  }
}

